// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-blue-haven -> repli-training-blue-haven -> blue-haven
// Generated: 2026-09-11T19:12:58.979Z
// Counts: 4 design, 12 content, 18 slot group, 0 collection binding, 5 section, 0 style

export const designOverrides = {
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for <br>Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Find Your Space</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Tour your way at Blue Haven.</strong> Explore one-, two-, and three-bedroom apartments with standout finishes, spacious screened-in porches, two shimmering pools, a 24-hour fitness center, and pet-friendly spaces—then schedule the tour that fits your day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The one-bedroom homes at Blue Haven make smart use of every square foot, pairing an open living-and-dining area with a fully equipped kitchen and a screened-in porch for easy indoor-outdoor living. Walk-in closets and in-home storage keep daily life uncluttered, while large windows fill the space with Tampa sunshine — an efficient, easy-to-love layout for one.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Blue Haven's two-bedroom, one-bath homes give you room to spread out, with a comfortable open living area that flows into a kitchen finished with stainless steel appliances and stone countertops. A screened porch extends your living space outdoors, and generous closets plus a second bedroom make this layout ideal for roommates, guests, or a work-from-home setup.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The larger two-bedroom, two-bath residences at Blue Haven pair a spacious living and dining area with two private bedroom suites, so everyone has their own retreat. An upgraded kitchen, double vanities, walk-in closets, and a screened porch round out a layout built for comfortable, everyday living in <a href=\"/neighborhood\">Hyde Park</a>.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel4_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The three-bedroom homes are the most expansive at Blue Haven, offering a bright, open floor plan with a modern kitchen, three roomy bedrooms, and abundant storage throughout. With a screened porch, walk-in closets, and premium finishes, it's a layout made for families, sharing, or simply having space to breathe. Explore the full range of <a href=\"/floor-plans\">floor plans</a> to find your fit.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitiesfeatures.apartmentBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-560e-73bc-a783-6d1321274fcc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open concept living area and kitchen with modern finishes."
      }
    }
  },
  "amenitiesfeatures.communityBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-9e50-7427-b92d-cb0bc45660aa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "MAA Hyde Park community swimming pool and lounge area"
      }
    }
  },
  "amenitiesintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-d529-75f3-b535-fad1c6615b4a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style swimming pool with lounge chairs and patio seating."
      }
    }
  },
  "amenitieslist.card0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Controlled Access"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4f77-7168-9e3c-205248dfd33e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sprawling apartment complex with a bright blue swimming pool and lush green landscaping, adjacent to a busy highway and a distant city skyline."
      }
    }
  },
  "amenitieslist.card1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "In-Home Laundry"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-c9b4-720b-a620-03089b14ef53.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and bedroom in a modern apartment."
      }
    }
  },
  "amenitieslist.card2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Property Manager on Site"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-1e29-7184-a9c3-cdb2319c6de2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community area with a dining table and chairs, and a reception desk in the background."
      }
    }
  },
  "amenitieslist.card3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Car Care Center"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-079e-7571-b396-95c991b51be4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor patio with seating, tables, and bar area."
      }
    }
  },
  "amenitieslist.card4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Furnished Units Available"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-9295-71de-b065-e5ca250d01ec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and dining area of an apartment with modern decor and colorful accents."
      }
    }
  },
  "amenitieslist.card5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Play Area"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-1c30-759f-953d-2747084ae579.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Gated outdoor dog park with green turf and a dog washing station."
      }
    }
  },
  "amenitieslist.card6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Planned Social Activities"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-0dbf-74b3-bddb-40699ac46629.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor kitchen and dining area with grills, seating, and a fireplace."
      }
    }
  },
  "amenitieslist.card7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Grill & Courtyard"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-0732-75d9-a399-01ff8b1358ea.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor patio with tables and chairs under a wooden pergola, overlooking a landscaped area and seating areas."
      }
    }
  },
  "discoveramenities.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4b41-767b-a48f-72a185d3bf19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fully equipped fitness center with treadmills, weight machines, and free weights."
      }
    }
  },
  "fullbleedstripe.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4f77-7168-9e3c-205248dfd33e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sprawling apartment complex with a bright blue swimming pool and lush green landscaping, adjacent to a busy highway and a distant city skyline."
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-d529-75f3-b535-fad1c6615b4a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style swimming pool with lounge chairs and patio seating."
      }
    }
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-8368-7088-a0bd-853d0e98bc1d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a white sofa, an orange accent chair, and abstract art."
      }
    }
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-560e-73bc-a783-6d1321274fcc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open concept living area and kitchen with modern finishes."
      }
    }
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-82c0-708a-ac81-906007328abe.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a large bed, orange and blue bedding, and two framed pictures on the wall."
      }
    }
  },
  "tabbedcallouts.panel4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-9295-71de-b065-e5ca250d01ec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and dining area of an apartment with modern decor and colorful accents."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
